import { SocialType } from "shared/SocialsShare/SocialsShare";
import React, { FC } from "react";
import { Grid } from "@mui/material";

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
  socials?: SocialType[];
}

const socials: SocialType[] = [{ name: "Instagram", icon: "lab la-instagram", href: "https://www.instagram.com/_flyinglab_/", label: "flying.lab" }];

const SocialsList: FC<SocialsListProps> = ({ className = "", itemClass = "block" }) => {
  return (
    <>
      {socials.map((item, i) => (
        <a key={i} href={item.href} target="_blank" rel="noreferrer">
          <Grid container style={{ borderWidth: 1, borderRadius: 20, padding: 10 }} justifyContent="center" alignItems="center">
            <i className={` ${item.icon}`}></i>
            <span className="text-sm">{" " + item.label}</span>
          </Grid>
        </a>
      ))}
    </>
  );
};

export default SocialsList;
